import { Resource } from "../resourcesSlice";
import {
  EditableResourceDetailsProps,
} from "./MailResourceHelpers";
import {
  ResourceDetailCardBase,
  TableFormElement,
} from "./ResourceDetailCardBase";
import { dropdown } from "./FormHelpers";
import { MattermostChannelResource } from "../../../proto/sip/resources/resources_pb";
import { GetStringForMattermostChannelMode } from "../../../util/resourcesProto";
import * as Yup from "yup";

const tableElements: TableFormElement<Resource>[] = [
  {
    title: "Mattermost Team",
    key: "mattermostChannel.team" as keyof Resource,
    validation: Yup.string().required(),
  },
  {
    title: "Mattermost Channel",
    key: "mattermostChannel.channel" as keyof Resource,
    validation: Yup.string().required(),
  },
  {
    title: "Sync Mode",
    key: "mattermostChannel.mode" as keyof Resource,
    formatter: GetStringForMattermostChannelMode,
    customFieldInputElement: dropdown([MattermostChannelResource.ChannelMode.STRICT, MattermostChannelResource.ChannelMode.ADD], GetStringForMattermostChannelMode),
  },
];

export const MattermostChannel = (
  props: EditableResourceDetailsProps<Resource>
) => (
  <ResourceDetailCardBase {...props}>{tableElements}</ResourceDetailCardBase>
);

export const mattermostChannelTableElements = tableElements;

